import { useDisclosure } from "@heroui/react";
import { useEffect, useState } from "react";
import { TicketTypeSelectionModal } from "./ticketTypeSelectionModal";
import { CreateUserToLandlordTicketModal } from "./createUserToLandlordTicketModal";
import { CreateToPlatformTicketModal } from "./createToPlatformTicketModal";

export function CreateTicketModal({
  disclosure,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
}) {
  const typeSelectionDisclosure = useDisclosure();
  const userToLandlordDisclosure = useDisclosure();
  const toPlatformDisclosure = useDisclosure();
  const [type, setType] = useState<"user_to_landlord" | "to_platform" | null>(
    null,
  );

  const handleSelectType = (
    type: "user_to_landlord" | "to_platform" | "cancel",
  ) => {
    if (type === "cancel") {
      setType(null);
      disclosure.onClose();
      return;
    } else if (type === "user_to_landlord") {
      setType("user_to_landlord");
      userToLandlordDisclosure.onOpen();
    } else {
      setType("to_platform");
      toPlatformDisclosure.onOpen();
    }
  };

  useEffect(() => {
    if (
      disclosure.isOpen &&
      !typeSelectionDisclosure.isOpen &&
      !userToLandlordDisclosure.isOpen &&
      !toPlatformDisclosure.isOpen
    ) {
      if (type == null) {
        typeSelectionDisclosure.onOpen();
      } else {
        disclosure.onClose();
        setType(null);
      }
    }
  }, [
    disclosure.isOpen,
    toPlatformDisclosure.isOpen,
    typeSelectionDisclosure,
    userToLandlordDisclosure.isOpen,
    type,
  ]);

  useEffect(() => {
    if (!disclosure.isOpen) {
      typeSelectionDisclosure.onClose();
      userToLandlordDisclosure.onClose();
      toPlatformDisclosure.onClose();
    }
  }, [
    disclosure.isOpen,
    toPlatformDisclosure,
    typeSelectionDisclosure,
    userToLandlordDisclosure,
  ]);

  return (
    <>
      <TicketTypeSelectionModal
        disclosure={typeSelectionDisclosure}
        onSelectType={handleSelectType}
      />

      <CreateUserToLandlordTicketModal disclosure={userToLandlordDisclosure} />

      <CreateToPlatformTicketModal disclosure={toPlatformDisclosure} />
    </>
  );
}
